import type { ColDef, ValueFormatterParams } from "ag-grid-community";
import type { GetPublicationsOutput } from "../../../../utils/trpc";
import { filterParams, PasswordStatusOptions } from "./utils";
import { PasswordStatusFilter } from "./PasswordStatusFilter";

export const userTableColDef = (publications?: GetPublicationsOutput) => {
  const baseColDef: ColDef[] = [
    { field: "email", initialSort: "asc" },
    { field: "name" },
    {
      field: "organisation",
      valueGetter: (params) => {
        if (params.data.organisation) {
          return params.data.organisation.name;
        }
        return "-";
      },
    },
    { field: "admin" },
    {
      field: "cognitoStatus",
      headerName: "Password Status",
      valueGetter: (params) => {
        const ssoStatus =
          params.data.organisation?.ssoStatus ?? params.data.ssoStatus;
        if (
          ssoStatus === "google_only" ||
          ssoStatus === "microsoft_only" ||
          ssoStatus === "sso_only"
        ) {
          return PasswordStatusOptions.SSO_ONLY;
        }
        if (params.data.cognitoStatus === "FORCE_CHANGE_PASSWORD") {
          return PasswordStatusOptions.TEMP_PASSWORD;
        }
        return PasswordStatusOptions.CONFIRMED;
      },
      filter: PasswordStatusFilter,
    },
    {
      field: "aiAccess",
      headerName: "AI Access",
    },
    {
      field: "lastModified",
      valueFormatter: function (params) {
        return new Date(params.value).toLocaleString("en-UK", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      field: "expiry",
      valueGetter: (params) => {
        if (params.data.organisation?.expiry) {
          return params.data.organisation.expiry;
        }
        return params.data.expiry;
      },
      valueFormatter: function (params) {
        if (!params.value) {
          return "-";
        }
        return new Date(params.value).toLocaleString("en-UK", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
      filter: "agDateColumnFilter",
      filterParams,
    },
  ];

  const publicationColDef: ColDef[] | undefined = publications
    ?.filter((pub) => pub.status === "PUBLISHED")
    .map((publication) => ({
      field: "publication-" + publication.id,
      headerName: publication.title,
      cellDataType: "boolean",
      cellRenderer: (params: ValueFormatterParams) => {
        return (
          <div className="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <div
              role="presentation"
              className="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-disabled"
            >
              <div
                className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ag-disabled ${params.value && "ag-checked"}`}
                role="presentation"
              >
                <input
                  className="ag-input-field-input ag-checkbox-input"
                  type="checkbox"
                  disabled
                  checked={!!params.value}
                />
              </div>
            </div>
          </div>
        );
      },
    }))
    .sort((a, b) =>
      a.headerName.localeCompare(b.headerName, undefined, {
        sensitivity: "base",
      }),
    );
  return [...baseColDef, ...(publicationColDef ?? [])];
};
